import { render, staticRenderFns } from "./TestbankQuestionSubjective.vue?vue&type=template&id=173a25fc&"
import script from "./TestbankQuestionSubjective.vue?vue&type=script&lang=js&"
export * from "./TestbankQuestionSubjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173a25fc')) {
      api.createRecord('173a25fc', component.options)
    } else {
      api.reload('173a25fc', component.options)
    }
    module.hot.accept("./TestbankQuestionSubjective.vue?vue&type=template&id=173a25fc&", function () {
      api.rerender('173a25fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Question/TestbankQuestionSubjective.vue"
export default component.exports